// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b723562c] h1 {\n  font-family: \"UniSans-Bold-Italic\";\n  text-align: center;\n}\n[data-v-b723562c] p {\n  text-align: left;\n  font-size: larger;\n}\n.page[data-v-b723562c] {\n  flex-flow: column;\n  background-color: white;\n  color: black;\n}\n.content[data-v-b723562c] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
